import React, { createContext, useContext, useState, useEffect } from 'react';
import io from 'socket.io-client';

export const SocketContext = createContext();

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Use relative URL in production, absolute URL in development
    const socketUrl = process.env.NODE_ENV === 'production' 
      ? window.location.origin // Use current domain in production
      : (process.env.REACT_APP_SOCKET_URL || 'http://127.0.0.1:4000');
    
    console.log('Connecting to Socket.IO at:', socketUrl);
    const newSocket = io(socketUrl);
    setSocket(newSocket);

    return () => newSocket.close();
  }, []);

  return (
    <SocketContext.Provider value={socket}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
